export const Role = {
  Admin: "Admin",
  DriverAdmin: "DriverAdmin",
  VehicleAdmin: "VehicleAdmin",
  HubAdmin: "HubAdmin",
  TripAdmin: "TripAdmin",
  Dispatcher: "Dispatcher",
  FinanceAdmin: "FinanceAdmin",
  // Owns the reference data behind a location: which hubs reach a point, and now whether a point
  // exists at all. Matches dbo.Role.RoleName exactly -- isUserInRole compares case-sensitively.
  LocationAdmin: "LocationAdmin"
};

export const TimeZoneLookup = {
  EST: "America/Cancun",
  EDT: "America/Detroit",
  CST: "America/Belize",
  CDT: "America/Chicago",
  MST: "America/Phoenix",
  MDT: "America/Denver",
  PDT: "America/Los_Angeles",
  UTC: "Etc/UTC",
};

export const EnsureTimeZoneFromAbbreviation = (abbv) => {
  let local = new Date().toLocaleTimeString("en-us", { timeZoneName: "short" }).split(" ")[2];

  if (!abbv) {
    return local;
  } else {
    abbv = abbv.toUpperCase();
    return TimeZoneLookup[abbv] ? abbv : local;
  }
};
export const GetTimeZoneFromAbbreviation = (abbv) => {
  let local = new Date().toLocaleTimeString("en-us", { timeZoneName: "short" }).split(" ")[2];
  
  if (!abbv) {
    return TimeZoneLookup[local];
  } else {
    abbv = abbv.toUpperCase();
    return TimeZoneLookup[abbv] ?? TimeZoneLookup[local];
  }
};
